export class StartQueryExecutionV2Request {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "query",
            "baseName": "query",
            "type": "string",
            "format": ""
        },
        {
            "name": "engine",
            "baseName": "engine",
            "type": "QueryEngine",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return StartQueryExecutionV2Request.attributeTypeMap;
    }
    constructor() {
    }
}
